<template>
  <div>
    <div>
      <form @submit.prevent="updateOverLoad">
        <div class="flex">
          <div class="mb-4 p-4">
            <h4>Mbi/Nen Ngarkesa</h4>
          </div>
          <div class="mb-4 p-4">
            <label class="inline-flex items-center">
              <input
                type="radio"
                v-model="overLoad.status"
                class="form-radio"
                name="radio"
                value="PO"
              />
              <span class="ml-2">PO</span>
            </label>
          </div>
          <div class="mb-4 p-4" v-show="overLoad.status === 'PO'">
            <label class="items-center">
              <span>MBI/NEN NGARKESE CKA?</span>
              <br />
              <textarea
                type="text"
                class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="radio"
                value="1"
                v-model="overLoad.comment"
              ></textarea>
            </label>
          </div>
          <div class="mb-4 p-4" v-show="overLoad.status === 'PO'">
            <label class="items-center">
              <span>RIORGANIZIMI</span>
              <br />
              <textarea
                type="text"
                class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="radio"
                value="3"
                v-model="overLoad.riorganizimi"
                :required="overLoad.status === 'PO'"
              ></textarea>
            </label>
          </div>
          <div class="mb-4 p-4">
            <label class="inline-flex items-center">
              <input
                type="radio"
                class="form-radio"
                name="radio"
                checked
                value="JO"
                v-model="overLoad.status"
                :required="overLoad.status === 'PO'"
              />
              <span class="ml-2">JO</span>
            </label>
          </div>
        </div>
        <div class="mb-4 p-4">
          <label
            class="block text-gray-700 text-sm font-bold mb-2"
            for="username"
            >DATA</label
          >
          <input
            type="date"
            class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="overLoad.day"
          />
        </div>
        <div class="flex">
          <div class="mb-4 pt-12">
            <div class="p-1">
              <button
                type="submit"
                class="block text-center uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
              >
                Ndrysho
              </button>
            </div>
            <div class="p-1">
              <router-link
                to="/excel"
                class="block text-center uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
                >Kthehu</router-link
              >
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      overLoad: {},
      hasOverLoad: false,
      id: this.$route.params.id,
    };
  },
  created() {
    this.getOverLoad();
  },
  methods: {
    getOverLoad() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/excel/ngarkesat/${this.id}`)
        .then((response) => {
          this.overLoad = response.data;
          // console.log(response);
        })
        .catch((error) => console.log(error));
    },
    updateOverLoad() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .put(`${process.env.VUE_APP_API}/excel/ngarkesat/${this.id}/update`, {
          status: this.overLoad.status,
          comment: this.overLoad.comment,
          type: "neser",
          riorganizimi: this.overLoad.riorganizimi,
          // type: this.overLoad.type
          day: this.overLoad.day,
        })
        .then(this.$router.push("/excel"))
        .then(
          this.$notify({
            group: "address",
            title: "Mbi/Nen Ngarkesa",
            text: "Mbi/Nen Ngarkesa u ndryshua",
          })
        )
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style></style>
